<template>
  <div class="w-full py-0">
    <div class="mx-auto w-full px-4 md:px-8">
      <div
        v-if="props.title"
        class="text-center font-medium text-muted-foreground opacity-35"
      >
        {{ props.title }}
      </div>
      <div
        :class="
          cn(
            'mask-animation group relative mt-6 flex gap-6 overflow-hidden p-2',
            props.class,
            { 'animations-enabled': isHydrated },
          )
        "
      >
        <div
          v-for="index in Array(5).fill(null)"
          :key="index"
          class="flex shrink-0 flex-row justify-around gap-6"
          :class="{ 'animate-logo-cloud': isHydrated }"
        >
          <NuxtImg
            v-for="(logo, key) in props.logos"
            :key="key"
            :src="logo.path"
            :alt="logo.name"
            class="h-14 w-36 px-2 brightness-0 dark:invert"
            quality="85"
            loading="lazy"
            height="56"
            width="144"
            sizes="144px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { cn } from '~/lib/utils'

interface Logo {
  name: string
  path: string
}
export interface AnimateLogoCloudProps {
  class?: string
  title?: string
  logos?: Logo[]
}

const props = defineProps<AnimateLogoCloudProps>()
const isHydrated = ref(false)

onMounted(() => {
  isHydrated.value = true
})
</script>

<style scoped>
.mask-animation.animations-enabled {
  mask-image: linear-gradient(
    to left,
    transparent 5%,
    black 20%,
    black 80%,
    transparent 95%
  );
}

.animate-logo-cloud {
  animation: logo-cloud 30s linear infinite;
}

@keyframes logo-cloud {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 4rem));
  }
}
</style>
